import React, { useState } from "react";

import {  useNavigate } from "react-router-dom";
import Moment from 'react-moment';
import { faMultiply } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PostApi } from "../../../../ApiClient/PostApi";


export default function PendingOrder(props) {

  const navigate = useNavigate();

  const [waybill, setWaybill] = useState(false);
  const [data, setData] = useState("");
  const toggleWayBill = async () => {
    const res = await PostApi("booking/order_detail", {
      bookingId: props.orderNo
    });
    setData(res.data.data)
    setWaybill(!waybill);
  };

  const complete_order = () => {
    localStorage.setItem("orderId", props.orderNo);
    navigate("/before_payment")
  }
  const order_details = (id) => {
    localStorage.setItem("orderId", id);
    navigate("/order_details");

}
  const review_order = () =>{
    navigate("/reviews",{state:{bookingId:props.orderNo}})
  }
  const proceed_to_payment = () =>{
    localStorage.setItem("orderId",props.orderNo)
    navigate("/payment_details")
  }
  const liStyle =
    "border border-black font-normal sm:text-base text-xs text-black py-2 sm:px-3 px-1 whitespace-nowrap";
  const thStyle =
    "border border-black font-medium sm:text-base text-xs text-black uppercase p-2";
  const tdStyle =
    "border border-black font-normal sm:text-base text-xs text-black text-opacity-60 p-2";

  return (
    <>
      <div className="bg-white rounded-md py-5 px-6 space-y-3">
        {/* <div className="flex sm:flex-row flex-col justify-between items-center">
          <h1 className="font-medium text-2xl text-themeRed">
            Order#{props.orderNo}
          </h1>
          <button onClick={toggleWayBill} className="font-normal text-xl text-themeBlue underline">
            {props.button}
          </button>
        </div> */}
        <span className="bg-themeRed p-3 text-white text-lg shadow-lg">Order ID : {props.orderNo}</span>
        {/* <h1 className="font-medium text-2xl sm:text-start text-center">
          {props.steps} Steps Left
        </h1> */}
        <p className="font-normal text-base text-black text-opacity-60 sm:text-start text-center">
          Started at <Moment format="D MMM , YYYY hh:mm a">
            {props.time}
          </Moment>
        </p>
        {/* <div className="flex gap-x-2 sm:justify-end justify-center"> */}
        <div className="grid grid-cols-2 gap-y-2">
          <div>
            <button
              onClick={() => proceed_to_payment()}
              className="font-medium text-md text-themeBlue2 bg-themeBlue7 py-2 px-4 w-[180px] text-center
            flex justify-center items-center gap-x-2"
            >
              
              <span>Proceed to Payment</span>
            </button>
          </div>
          <div>
            <button
              onClick={complete_order}
              className="font-medium text-md text-themeBlue2 bg-themeBlue7 py-2 px-4 w-[180px] text-center
            flex justify-center items-center gap-x-2"
            >
              
              <span >{props.button2}</span>
            </button>
          </div>
          <div>
            <button
              onClick={() => order_details(props.orderNo)}
              className="font-medium text-md text-themeBlue2 bg-themeBlue7 py-2 px-4 w-[180px] text-center
            flex justify-center items-center gap-x-2"
            >
              
              <span>Details</span>
            </button>
          </div>
          <div>
            <button
              onClick={review_order}
              className="font-medium text-md text-themeBlue2 bg-themeBlue7 py-2 px-4 w-[180px] text-center
            flex justify-center items-center gap-x-2"
            >
              <span>Notes</span>
            </button>
          </div>
         

        </div>
      </div>


      <div
        className={`${waybill ? "block" : "hidden"
          } absolute w-full h-fit top-0 bg-black bg-opacity-50 z-[60]`}
      >
        <div className="relative xl:w-4/6 lg:w-4/5 w-[96%] left-[50%] -translate-x-[50%] bg-white">
          <div
            className="border-2 border-black border-opacity-60 float-right 
              rounded-fullest cursor-pointer sm:text-black h-6 w-6 inline-flex 
              justify-center items-center mr-3 mt-3"
            onClick={toggleWayBill}
          >
            <FontAwesomeIcon
              icon={faMultiply}
              className="text-black text-opacity-60"
            />
          </div>
          <div className="my-16 sm:px-8 px-4 py-12 sm:space-y-8 space-y-6">
            <h1 className="font-medium sm:text-4xl text-3xl text-black text-opacity-60 text-center">
              ORDER#{data?.order?.id ?? "0"}
            </h1>
            <div className="flex items-center sm:gap-x-[33%] gap-x-[20%]">
              <div>
                <img
                  src="images/myOrders/qr.webp"
                  className="md:w-40 sm:w-28 w-20"
                  alt=""
                />
              </div>
              <div className="-translate-x-[20%]">
                <img
                  src="images/logo2.webp"
                  className="md:w-56 sm:w-40 w-32"
                  alt=""
                />
              </div>
            </div>
            <div
              className="flex md:flex-row flex-col md:items-center md:justify-between 
              gap-y-5 overflow-hidden"
            >
              <div className="space-y-2">
                <p className="font-medium sm:text-base text-sm text-black text-opacity-60 uppercase">
                  Expected Hub Arrival Date:{" "}
                  <span className="font-bold text-black"><Moment format="D MMM , YYYY hh:mm a">
                    {data?.order?.expectedHubArrivalDate}
                  </Moment></span>
                </p>
                <p className="font-medium sm:text-base text-sm text-black text-opacity-60 uppercase">
                  Actual Hub Arrival Date:{" "}
                  <span
                    className="relative before:content-[''] before:absolute before:bottom-0 before:left-2 
                    before:w-28 before:h-0.5 before:bg-black"
                  ></span>
                </p>
              </div>
              <div className="space-y-2">
                <p className="font-medium sm:text-base text-sm text-black text-opacity-60 uppercase">
                  Expected Consol Numner:{" "}
                  <span className="font-bold text-black">34545-YUKJOI</span>
                </p>
                <p className="font-medium sm:text-base text-sm text-black text-opacity-60 uppercase">
                  Actual Consol Number:{" "}
                  <span
                    className="relative before:content-[''] before:absolute before:bottom-0 before:left-2 
                    before:w-36 before:h-0.5 before:bg-black"
                  ></span>
                </p>
              </div>
            </div>
            <table className="w-full [&>thead>tr>th]:text-start">
              <thead>
                <tr>
                  <th className={thStyle}>DIMENSIONS</th>
                  <td className={tdStyle}>Length (cm)</td>
                  <td className={tdStyle}>Width (cm)</td>
                  <td className={tdStyle}>Height (cm)</td>
                  <td className={tdStyle}>Weight (kg)</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className={tdStyle}>Captured</td>
                  <td className={tdStyle}>{data.package_length ?? "0"}</td>
                  <td className={tdStyle}>{data.package_width ?? "0"}</td>
                  <td className={tdStyle}>{data.package_height ?? "0"}</td>
                  <td className={tdStyle}>{data.package_weight ?? "0"}</td>
                </tr>
                <tr>
                  <td className={tdStyle}>Measured</td>
                  <td className={tdStyle}></td>
                  <td className={tdStyle}></td>
                  <td className={tdStyle}></td>
                  <td className={tdStyle}></td>
                </tr>
              </tbody>
            </table>
            <h1 className="font-normal sm:text-2xl text-lg text-themeRed text-center uppercase ">
              Packages without a waybill attached will not be accepted
            </h1>
            <div>
              <h1 className="font-normal sm:text-xl text-lg uppercase text-white bg-themeGray3 px-5 py-2">
                Send Packages to below address
              </h1>
              <div
                className="flex sm:flex-row flex-col sm:justify-between sm:items-center 
                px-5 py-3 border border-black gap-y-5"
              >
                <ul className="[&>li]:font-normal [&>li]:text-base sm:space-y-3 space-y-1">
                  <li>Pacifrica</li>
                  <li>{data?.order?.DestinationDetail?.address ?? "Address"}</li>
                  <li>{data?.order?.DestinationDetail?.postalCode ?? "Postal Code"} {data?.order?.DestinationDetail?.city ?? "City"}</li>
                  <li>{data?.order?.DestinationDetail?.province ?? "Province"}</li>
                  <li>{data?.order?.DestinationDetail?.email ?? "Email"}</li>
                  <li>{data?.order?.DestinationDetail?.phone ?? "Phone"}</li>
                </ul>
                <ul className="[&>li]:font-normal [&>li]:text-base sm:space-y-3 space-y-1">
                  <li>Pacifrica</li>
                  <li>{data?.order?.DestinationDetail?.address ?? "Address"}</li>
                  <li>{data?.order?.DestinationDetail?.postalCode ?? "Postal Code"} {data?.order?.DestinationDetail?.city ?? "City"}</li>
                  <li>{data?.order?.DestinationDetail?.province ?? "Province"}</li>
                  <li>{data?.order?.DestinationDetail?.email ?? "Email"}</li>
                  <li>{data?.order?.DestinationDetail?.phone ?? "Phone"}</li>
                </ul>
              </div>
            </div>
            <div className="grid md:grid-cols-2 gap-x-5 sm:gap-y-8 gap-y-6">
              <div>
                <h1
                  className="font-normal sm:text-xl text-lg uppercase text-white bg-themeGray3 
                  px-3 py-2 border border-black"
                >
                  Supplier Details
                </h1>
                <div className="flex">
                  <ul className="[&>li]:font-normal [&>li]:sm:text-base [&>li]:text-sm">
                    <li className={liStyle}>Company</li>
                    <li className={liStyle}>Name</li>
                    <li className={liStyle}>Email</li>
                    <li className={liStyle}>Number</li>
                  </ul>
                  <ul className="[&>li]:font-normal [&>li]:sm:text-base [&>li]:text-sm w-full">
                    <li className={liStyle}>{data?.order?.SupplierDetail?.companyName ?? "Company Name"}</li>
                    <li className={liStyle}>{data?.order?.SupplierDetail?.contactName ?? "Name"}</li>
                    <li className={liStyle}>{data?.order?.SupplierDetail?.email ?? "Email"}</li>
                    <li className={liStyle}>{data?.order?.SupplierDetail?.phone ?? "PH#"}</li>
                  </ul>
                </div>
              </div>
              <div>
                <h1
                  className="font-normal sm:text-xl text-lg uppercase text-white bg-themeGray3 
                  px-3 py-2 border border-black"
                >
                  Consignee Details
                </h1>
                <div className="flex">
                  <ul className="[&>li]:font-normal [&>li]:text-base">
                    <li className={liStyle}>Company</li>
                    <li className={liStyle}>Name</li>
                    <li className={liStyle}>Email</li>
                    <li className={liStyle}>Number</li>
                  </ul>
                  <ul className="[&>li]:font-normal [&>li]:text-base w-full">
                    <li className={liStyle}>{data?.order?.ConsigneeDetail?.companyName ?? "Company Name"}</li>
                    <li className={liStyle}>{data?.order?.ConsigneeDetail?.contactName ?? "Name"}</li>
                    <li className={liStyle}>{data?.order?.ConsigneeDetail?.email ?? "Email"}</li>
                    <li className={liStyle}>{data?.order?.ConsigneeDetail?.phone ?? "PH#"}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div>
              <h1
                className="font-normal sm:text-xl text-lg uppercase text-white bg-themeGray3 px-3 py-2  
                border border-black"
              >
                Destination Details
              </h1>
              <div className="flex">
                <ul>
                  <li className={liStyle}>Company</li>
                  <li className={liStyle}>Address 1</li>

                  <li className={liStyle}>Postal Code</li>
                  <li className={liStyle}>City</li>
                  <li className={liStyle}>Province</li>
                  <li className={liStyle}>Country</li>
                </ul>
                <ul className="w-full">
                  <li className={liStyle}>{data?.order?.DestinationDetail?.companyName ?? "Company Name"}</li>
                  <li className={liStyle}>{data?.order?.DestinationDetail?.companyName ?? "Company Name"}</li>

                  <li className={liStyle}>{data?.order?.DestinationDetail?.postalCode ?? "Postal Code"}</li>
                  <li className={liStyle}>{data?.order?.DestinationDetail?.city ?? "city"}</li>
                  <li className={liStyle}>{data?.order?.DestinationDetail?.province ?? "Province"}</li>
                  <li className={liStyle}>{data?.order?.DestinationDetail?.country ?? "Country"}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
